
import { LineChart } from 'react-native-chart-kit';
import { Text, View, Pressable } from 'react-native';
import React, { useState } from 'react';

interface Chart {
    reportData?: any,
    chartTitle?: string
}

const Chart = ({ reportData, chartTitle, ...props }: Chart) => {

    const longLabel = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const shortLabel = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const [chartParentWidth, setChartParentWidth] = useState(500);

    return (
        <View style={{ flex: 1 }}>
            <Text style={{ flex: .1, minHeight: 50 }}>Chart Title</Text>
            <View style={{ flex: 1 }}>
                <View style={{ flex: 1 }}
                    onLayout={({ nativeEvent }) => setChartParentWidth(nativeEvent.layout.width)}
                >
                    <LineChart
                        data={reportData ? reportData : {
                            labels: chartParentWidth > 700 ? longLabel : shortLabel,
                            datasets: [
                                {
                                    data: [
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100,
                                        Math.random() * 100
                                    ]
                                }
                            ]
                        }}
                        height={200}
                        bezier
                        width={chartParentWidth}
                        yAxisLabel='£'
                        withVerticalLabels={true}
                        withHorizontalLabels={true}
                        chartConfig={{
                            backgroundGradientFromOpacity: 0,
                            backgroundGradientToOpacity: 0,
                            fillShadowGradient: 'transparent',
                            fillShadowGradientFrom: 'transparent',
                            fillShadowGradientTo: 'transparent',
                            fillShadowGradientOpacity: 0.4,
                            decimalPlaces: 0, // optional, defaults to 2dp
                            color: (opacity = 1) => `rgba(90, 192, 234, ${opacity})`,
                            labelColor: (opacity = 1) => `black`,
                            style: {
                                borderRadius: 25,
                                shadowOpacity: 1,
                                zIndex: 3,
                                paddingLeft: 5
                            },
                            propsForDots: {
                                r: "5",
                                strokeWidth: "2",
                                stroke: "#ffa726"
                            },
                        }}
                        style={{
                            borderRadius: 20,
                            backgroundColor: "rgba(90,192,234,1)",
                            flex: 1,
                            shadowOpacity: 0.4,
                        }}
                        onDataPointClick={({ value, getColor }) =>
                            console.log(value, getColor)
                        }
                    />
                    <View style={{ flexDirection: 'row', gap: 20, borderRadius: 40, backgroundColor: 'white', flex: 1, minHeight: 50 }}
                    >
                        <Pressable><Text adjustsFontSizeToFit >Year</Text></Pressable>
                        <Pressable><Text adjustsFontSizeToFit >Month</Text></Pressable>
                        <Pressable><Text adjustsFontSizeToFit >Week</Text></Pressable>
                    </View>
                    </View>
            </View>
        </View>
    );
}

export default Chart;